/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineRule {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return TagBaselineRule.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineRule>): TagBaselineRule {
        let obj = Object.assign(new TagBaselineRule(), model);
        TagBaselineRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineRule>): TagBaselineRule {
        if (!model) return null;
        return TagBaselineRule.newInstance(<TagBaselineRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineRule) {
        if (!obj) return;

        models.TagBaselineRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineRule): boolean {
        switch (obj.__type)
        {
            case "TagBaselineRuleAllowedValues":
                Object.setPrototypeOf(obj, models.TagBaselineRuleAllowedValues.prototype);
                break;
            case "TagBaselineRuleCondition":
                Object.setPrototypeOf(obj, models.TagBaselineRuleCondition.prototype);
                break;
            case "TagBaselineRuleRegex":
                Object.setPrototypeOf(obj, models.TagBaselineRuleRegex.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof TagBaselineRule)[] {
        return [
            models.TagBaselineRuleAllowedValues,
            models.TagBaselineRuleCondition,
            models.TagBaselineRuleRegex,
        ];
    }

    fixupFields() {
    }

    /**
     * Categories for this tag
     */
    category: Array<string>;

}
